import { resolveTemplate } from "@/modules/_shared/templateValue";
import type { CellModule } from "@/modules/_shared/contract";

export const templateModule: CellModule = {
  kind: "template",
  capability: "cell",
  name: "Combine Text",
  tooltip: "Join columns and your own text together",
  description: "Builds this column by mixing your columns with words you type. Type / in the editor to load a column.",
  category: "Basics",
  tags: ["interpolation", "merge", "fields", "format"],
  icon: { kind: "lucide", name: "Braces" },
  tone: "indigo",
  defaultConfig: () => ({ kind: "template", value: "" }),
  resolve: (rule, { row, helpers, output }) => {
    if (rule.kind !== "template") return "";
    return resolveTemplate(rule.value, { row, helpers, output });
  },
  templateStrings: (rule) => (rule.kind === "template" ? [rule.value] : []),
};
